module.exports = __webpack_public_path__ + "static/img/modals-sizing-small.7c2e6f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/modals-sizing-small.svg
// module id = QYZd
// module chunks = 0